define('score_bootstrap/Models/Search/FacetPanel',[
    "jquery",
    "knockout",
    "underscore",
    "score_bootstrap/Models/SitecoreId"
], function ($, ko, _, SitecoreId) {
    "use strict";

    var searchLogic = [ "and", "or_total_count", "or_incremental_count" ];

    function FacetValue(id, value, text, rowElement, isPreselected) {
        var self = this;

        this.id        = SitecoreId.parse(id);
        this.value = value;
        this.text = text;
        this.selected  = ko.observable(isPreselected);
        this.count     = ko.observable(0);

        this.disabled = ko.computed(function () {
            var count = self.count();
            return count === 0 || parseInt(count, 10) === 0;
        });

        this.resetCount = function () {
            this.count(0);
        };

        ko.applyBindings(this, rowElement);
    }

    function FacetPanel(panelElement, allPreselected) {
        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.attr("data-title"),
            searchLogicType = $dataEl.attr("data-search-logic-type").toLowerCase(),
            preselectedByTitle = allPreselected[title] || "",
            facets = [];

        $(".js-row", panelElement).each(function () {
            var $el = $(this),
                id = $el.attr("data-id"),
                val = $el.attr("data-value"),
                text = $el.find('.score-facet-value').text();
            facets.push(new FacetValue(id, val, text, $el[0], preselectedByTitle.indexOf(val) > -1));
        });

        Object.defineProperties(this, {
            title:           { value: title },
            searchLogicType: { value: searchLogic.indexOf(searchLogicType) },
            facets:          { get: Array.prototype.slice.bind(facets) },
            asString: {
                get: function () {
                    var result = facets.reduce(function (result, facet) {
                        return facet.selected() ? (result + facet.value + "|") : result;
                    }, "");

                    return result ? (this.title + ":" + result.slice(0, -1)) : null;
                }
            }
        });

        this.selectValues = function(selectedValues) {
            var selectedByTitle = selectedValues[title] || "";
            facets.forEach(function (facet) {
                var oldValue = facet.selected();
                var newValue = selectedByTitle.indexOf(facet.value) > -1;
                if (oldValue !== newValue) {
                    facet.selected(selectedByTitle.indexOf(facet.value) > -1);
                }
            });
        };

        this.selectedValues = ko.pureComputed(function () {
            return _.filter(facets, function (val) {
                return val.selected();
            });
        });

        this.unselectAll = function unselectAll() {
            this.selectedValues().forEach(function (value) {
                value.selected(false);
            });
        };
    }

    return FacetPanel;
});
